import React, { useState, useEffect, useRef } from 'react';
import { Dialog } from "primereact/dialog";
import { InputNumber } from "primereact/inputnumber";
import { InputText } from "primereact/inputtext";
import { FloatLabel } from "primereact/floatlabel";
import { Link, Navigate, resolvePath } from "react-router-dom";
import {config} from "../shared/config";
import * as util from '../shared/commons';
import axios from "axios";
import { Button } from 'primereact/button';
import 'primeicons/primeicons.css';
import { Image } from "primereact/image";
import ShowError from "../shared/ShowError";
import { Skeleton } from 'primereact/skeleton';
import { Toast } from 'primereact/toast';
import TeacherCombo from '../combos/TeacherCombo';
import SchoolClassCombo from '../combos/SchoolClassCombo';
import { Col, Form, Row } from 'react-bootstrap';
import { Checkbox } from 'primereact/checkbox';
import ShowVideo from '../shared/ShowVideo';



export default function SchoolTimingReplace(props) {
    const toast = useRef(null);
    const [errorVisible, setErorVisible] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [saving, setSaving] = useState(false);
    const [teachers, setTeachers] = useState([]);
    const [classes, setClasses] = useState([]);
    const [courses, setCourses] = useState([]);
    const [weekDays, setWeakDays] = useState([]);
    const [teacher, setTeacher] = useState(null);
    const [redirectUrl, setRedirectUrl] = useState("");

    const [chkClassAll, setChkClassAll] = useState(false);
    const [chkClassSelection, setChkClassSelection] = useState(true);
    const [chkCourseAll, setChkCourseAll] = useState(false);
    const [chkCourseSelection, setChkCourseSelection] = useState(true);
    const [chkTeacherAll, setChkTeacherAll] = useState(false);
    const [chkTeacherSelection, setChkTeacherSelection] = useState(true);
    const [chkWeekDayAll, setChkWeekDayAll] = useState(false);
    const [chkWeekDaySelection, setChkWeekDaySelection] = useState(true);

    

    useEffect(() => {
      setSaving(true);
      var params = {login:util.getTrustedUser()};
      var url = config.Server+`/school/school-data/all/list`;
      console.log("params is>", params);
      console.log("url is>", url);
      axios
          .post(url, params )
          .then(res => {
              var response = res.data;
              if(response.state === "ok"){
                  response = response.data;
                  var classesTmp = response.classes;
                  for(var i=0;i<classesTmp.length;i++){
                    classesTmp[i]["isChecked"] = false;
                  }
                  setClasses(classesTmp);

                  var coursesTmp = response.allCourses;
                  for(var i=0;i<coursesTmp.length;i++){
                    coursesTmp[i]["isChecked"] = false;
                    for(var j=0;j<coursesTmp[i].courses.length;j++){
                      coursesTmp[i].courses[j]["isChecked"] = false;
                    }
                    
                  }
                  setCourses(coursesTmp);

                  var teachersTmp = response.teachers;
                  for(var i=0;i<teachersTmp.length;i++){
                    teachersTmp[i]["isChecked"] = false;
                  }
                  setTeachers(teachersTmp);

                  var weekDaysTmp = [];
                  for(var i=0;i<7;i++){
                    weekDaysTmp.push({code:String(i), name:util.getWeekDayName(i), isChecked:false});
                  }
                  setWeakDays(weekDaysTmp);
                  
                  setSaving(false);
                  
              }
              else{
                  setErrorMessage(response.message);
                  setErorVisible(true);
                  setSaving(false);
              }
          })
          .catch(error => {
              setErrorMessage(error.code + "," + error.message);
              setErorVisible(true);
              setSaving(false);
          });
    }, []);
    const checkDataEntry = function(){
      if(teacher == null){
        setErorVisible(true);
        setErrorMessage("معلم را انتخاب نمائید");
        return false;
      }
      return true;
    }

    const saveItem = function(){
      if(!checkDataEntry()) return;
      var classesTmp = [];
      var coursesTmp = [];
      var teachersTmp = [];
      var weekDaysTmp = [];

      for(var i=0;i<classes.length;i++)
        if(classes[i].isChecked)
          classesTmp.push(classes[i].code);

      for(var i=0;i<courses.length;i++)
        for(var j=0;j<courses[i].courses.length;j++)
          if(courses[i].courses[j].isChecked)
            coursesTmp.push(courses[i].courses[j].code);

      for(var i=0;i<teachers.length;i++)
        if(teachers[i].isChecked)
          teachersTmp.push(teachers[i].code);

      for(var i=0;i<weekDays.length;i++)
        if(weekDays[i].isChecked)
          weekDaysTmp.push(parseInt(weekDays[i].code));

      
      if((coursesTmp.length == 0)&&(classesTmp.length == 0)){
        setErorVisible(true);
        setErrorMessage("هیچ درسی یا کلاسی انتخاب نشده است");
        return false;
      }
      
      if(weekDaysTmp.length == 0){
        setErorVisible(true);
        setErrorMessage("هیچ روزی از هفته انتخاب نشده است");
        return false;
      }
      var params = {
        login:util.getTrustedUser(), 
        teacherId:teacher.id,
        schoolClasses:classesTmp,
        courses:coursesTmp,
        teachers:teachersTmp,
        weekDays:weekDaysTmp,
      };
      var url = config.Server+`/school/timing/replace/teacher`;
      console.log("params to replace is>", params)
      
      setSaving(true);
        axios
          .post(url, params )
          .then(res => {
              var response = res.data;
              if(response.state === "ok"){
                toast.current.show({ severity: 'info', summary: 'Info', detail: 'با موفقیت ثبت شد' });              
                setSaving(false);
                setTeacher(null);
              }
              else{
                  setErrorMessage(response.message);
                  setErorVisible(true);
                  setSaving(false);
              }
          })
          .catch(error => {
              setErrorMessage(error.code + "," + error.message);
              setErorVisible(true);
              setSaving(false);
          });

    }
    const onClassCheckboxesChange = (e, isAll, index) => {
        var tmp = [...classes];
        if(index == -1){
          if(isAll) {
            setChkClassAll(true);
            setChkClassSelection(false);
            for(var i=0;i<tmp.length;i++)tmp[i].isChecked = true;
          }
          else{
            setChkClassAll(false);
            setChkClassSelection(true);
          }
        }
        else{
          tmp[index].isChecked = e.checked;
        }
        setClasses(tmp);
    }
    const onCourseCheckboxesChange = (e, isAll, index, subInd) => {
        var tmp = [...courses];
        if(index == -1){
          if(isAll) {
            setChkCourseAll(true);
            setChkCourseSelection(false);
            for(var i=0;i<tmp.length;i++){
              tmp[i].isChecked = true;
              for(var j=0;j<tmp[i].courses.length;j++)
                tmp[i].courses[j].isChecked = true;
            }
          }
          else{
            setChkCourseAll(false);
            setChkCourseSelection(true);
          }
        }
        else{
          tmp[index].courses[subInd].isChecked = e.checked;
        }
        setCourses(tmp);
    }
    const onCourseByDegreeCheckboxesChange = (e, field, degree) =>{
      var tmp = [...courses];
      for(var i=0;i<tmp.length;i++){
        if((tmp[i].degree == degree)&&(tmp[i].field.id == field.id)){
          tmp[i].isChecked = e.checked;
          for(var j=0;j<tmp[i].courses.length;j++)
            tmp[i].courses[j].isChecked = e.checked;
        }
      }
      setCourses(tmp);
    }
    const onTeacherCheckboxesChange = (e, isAll, index) => {
        var tmp = [...teachers];
        if(index == -1){
          if(isAll) {
            setChkTeacherAll(true);
            setChkTeacherSelection(false);
            for(var i=0;i<tmp.length;i++)tmp[i].isChecked = true;
          }
          else{
            setChkTeacherAll(false);
            setChkTeacherSelection(true);
          }
        }
        else{
          tmp[index].isChecked = e.checked;
        }
        setTeachers(tmp);
    }
    const onWeekDayCheckboxesChange = (e, isAll, index) => {
        var tmp = [...weekDays];
        if(index == -1){
          if(isAll) {
            setChkWeekDayAll(true);
            setChkWeekDaySelection(false);
            for(var i=0;i<tmp.length;i++)tmp[i].isChecked = true;
          }
          else{
            setChkWeekDayAll(false);
            setChkWeekDaySelection(true);
          }
        }
        else{
          tmp[index].isChecked = e.checked;
        }
        setWeakDays(tmp);
    }
    return(      
      (redirectUrl != "")
          ?
          <Navigate to={redirectUrl} replace={false}  />
      :
      <>
      <ShowVideo videoId="school_timing" top={65} md={6} />
         <Row style={{paddingTop:"10px"}}>
            <Col md={2}>
                <label onClick={()=>setRedirectUrl("/school/timing")} style={{cursor:"pointer", color:"#3e9aff"}}>
                <img src={require('../lib/images/back.png')} width={24} />
                برگشت به برنامه هفتگی
                </label>
            </Col>
         </Row>
         <Row style={{paddingTop:"0px", margin:"5px", border:"1px solid #b0b0b0", borderRadius:"5px"}}>
            <Col md={12} style={{backgroundColor:"royalblue", color:"#FFFFFF",padding:"5px", borderRadius:"5px", fontSize:"14pt"}}>
                جایگزینی معلم در برنامه هفتگی
            </Col>
            <Row>
              <Col md={3}>
                <TeacherCombo returnFullItem={true} value={teacher} onChange={(val) => setTeacher(val)}/>  
              </Col>
            </Row>
            
            <Row style={{marginTop:"15px"}}>
              <Col md={12}>
                  <div className="flex align-items-center" style={{marginTop:"10px"}}>
                      <Checkbox inputId="chk1" onChange={(e)=>{onClassCheckboxesChange(e, true, -1)}} checked={chkClassAll} />
                      <label htmlFor="chk1" className="ml-2"> &nbsp;جایگزینی در همه کلاس ها</label>
                  </div>                
              </Col>
              <Col md={12}>
                  <div className="flex align-items-center" style={{marginTop:"10px"}}>
                      <Checkbox inputId="chk2" onChange={(e)=>{onClassCheckboxesChange(e, false, -1)}} checked={chkClassSelection} />
                      <label htmlFor="chk2" className="ml-2"> &nbsp;جایگزینی فقط در کلاس های زیر</label>
                  </div>
              </Col>
              <Col md={12} style={{border:"1px solid #b0b0b0", margin:"5px 25px 5px 50px", width:"calc(100% - 10px", padding:"3px", maxHeight:"450px", overflowY:"scroll"}}>
                {
                  classes.map((cls, index)=>{
                    return(
                      <div className="flex align-items-center" style={{marginTop:"5px", width:"150px", float:"right", height:"30px", overflow:"hidden"}}>
                          <Checkbox disabled={chkClassAll} inputId={"chk3_" + String(index)} onChange={(e)=>{onClassCheckboxesChange(e, false, index)}}  checked={classes[index].isChecked} />
                          <label htmlFor={"chk3_" + String(index)} className="ml-2"> &nbsp;{cls.name}</label>
                      </div>
                    )
                  })
                }
              </Col>
            </Row>
            
            <Row style={{marginTop:"15px"}}>
              <Col md={12}>
                  <div className="flex align-items-center" style={{marginTop:"10px"}}>
                      <Checkbox inputId="chk4" onChange={(e)=>{onCourseCheckboxesChange(e, true, -1, -1)}} checked={chkCourseAll} />
                      <label htmlFor="chk4" className="ml-2"> &nbsp;جایگزینی در همه درس ها</label>
                  </div>                
              </Col>
              <Col md={12}>
                  <div className="flex align-items-center" style={{marginTop:"10px"}}>
                      <Checkbox inputId="chk5" onChange={(e)=>{onCourseCheckboxesChange(e, false, -1, -1)}} checked={chkCourseSelection} />
                      <label htmlFor="chk5" className="ml-2"> &nbsp;جایگزینی فقط در درس های زیر</label>
                  </div>
              </Col>
              <Col md={12} style={{border:"1px solid #b0b0b0", margin:"5px 25px 5px 50px", width:"calc(100% - 10px", padding:"3px", maxHeight:"450px", overflowY:"scroll"}}>
                {
                  courses.map((main, index)=>{
                    return(
                      <div style={{marginTop:"5px", width:"293px", float:"right", border:"2px dashed orange", borderLeft:"2px dashed orange", margin:"3px", padding:"5px"}}>
                        <div style={{position:"relative", textAlign:"center", backgroundColor:"#eee", marginTop:"1px", width:"280px", float:"top", height:"30px", paddingTop:"5px", overflow:"hidden"}}>
                          {main.field.title} - پایه {main.degree}
                          <Checkbox style={{position:"absolute", top:"3px", right:"3px"}} disabled={chkCourseAll} onChange={(e)=>{onCourseByDegreeCheckboxesChange(e, main.field, main.degree)}}  checked={courses[index].isChecked} />
                        </div>
                      {
                        main.courses.map((cls, subInd)=>{
                          return(
                            <div className="flex align-items-center" style={{marginTop:"5px", width:"280px", float:"top", height:"30px", overflow:"hidden"}}>
                                <Checkbox disabled={chkCourseAll} inputId={"chk6_" + String(index) + "_" + String(subInd)} onChange={(e)=>{onCourseCheckboxesChange(e, false, index, subInd)}}  checked={courses[index].courses[subInd].isChecked} />
                                <label htmlFor={"chk6_" + String(index) + "_" + String(subInd)} className="ml-2"> &nbsp;{cls.name}</label>
                            </div>
                          )
                        })
                      }
                      </div>
                    )
                  })
                }
              </Col>
            </Row>
            
            <Row style={{marginTop:"15px"}}>
              <Col md={12}>
                  <div className="flex align-items-center" style={{marginTop:"10px"}}>
                      <Checkbox inputId="chk7" onChange={(e)=>{onTeacherCheckboxesChange(e, true, -1)}} checked={chkTeacherAll} />
                      <label htmlFor="chk7" className="ml-2"> &nbsp;جایگزینی با همه معلم ها</label>
                  </div>                
              </Col>
              <Col md={12}>
                  <div className="flex align-items-center" style={{marginTop:"10px"}}>
                      <Checkbox inputId="chk8" onChange={(e)=>{onTeacherCheckboxesChange(e, false, -1)}} checked={chkTeacherSelection} />
                      <label htmlFor="chk8" className="ml-2"> &nbsp;جایگزینی فقط با معلم های زیر</label>
                  </div>
              </Col>
              <Col md={12} style={{border:"1px solid #b0b0b0", margin:"5px 25px 5px 50px", width:"calc(100% - 10px", padding:"3px", maxHeight:"450px", overflowY:"scroll"}}>
                {
                  teachers.map((cls, index)=>{
                    return(
                      <div className="flex align-items-center" style={{marginTop:"5px", width:"300px", float:"right", height:"45px", overflow:"hidden"}}>
                          <Checkbox disabled={chkTeacherAll} inputId={"chk9_" + String(index)} onChange={(e)=>{onTeacherCheckboxesChange(e, false, index)}}  checked={teachers[index].isChecked} />
                          <label htmlFor={"chk9_" + String(index)} className="ml-2"> &nbsp;{cls.name}</label>
                      </div>
                    )
                  })
                }
              </Col>
            </Row>
            
            <Row style={{marginTop:"15px"}}>
              <Col md={12}>
                  <div className="flex align-items-center" style={{marginTop:"10px"}}>
                      <Checkbox inputId="chk10" onChange={(e)=>{onWeekDayCheckboxesChange(e, true, -1)}} checked={chkWeekDayAll} />
                      <label htmlFor="chk10" className="ml-2"> &nbsp;جایگزینی در همه روز ها</label>
                  </div>                
              </Col>
              <Col md={12}>
                  <div className="flex align-items-center" style={{marginTop:"10px"}}>
                      <Checkbox inputId="chk11" onChange={(e)=>{onWeekDayCheckboxesChange(e, false, -1)}} checked={chkWeekDaySelection} />
                      <label htmlFor="chk11" className="ml-2"> &nbsp;جایگزینی فقط در روز های زیر</label>
                  </div>
              </Col>
              <Col md={12} style={{border:"1px solid #b0b0b0", margin:"5px 25px 5px 50px", width:"calc(100% - 10px", padding:"3px", maxHeight:"450px", overflowY:"scroll"}}>
                {
                  weekDays.map((cls, index)=>{
                    return(
                      <div className="flex align-items-center" style={{marginTop:"5px", width:"150px", float:"right", height:"30px", overflow:"hidden"}}>
                          <Checkbox disabled={chkWeekDayAll} inputId={"chk12_" + String(index)} onChange={(e)=>{onWeekDayCheckboxesChange(e, false, index)}}  checked={weekDays[index].isChecked} />
                          <label htmlFor={"chk12_" + String(index)} className="ml-2"> &nbsp;{cls.name}</label>
                      </div>
                    )
                  })
                }
              </Col>
            </Row>
            
            <Row style={{margin :"20px 0px"}}>
              <Col md={3}>
                  <div className="card flex justify-content-center" style={{ direction: "ltr", textAlign:"right" }}>
                    <Button label="مغلم جایگزین شود" icon="pi pi-check" onClick={()=>saveItem(true)} severity="success" iconPos="right" loading={saving} />                    
                  </div>
              </Col>
            </Row>
         </Row>
          <ShowError visible={errorVisible} message={errorMessage} closeError={()=>{setErorVisible(false)}} />
          <Toast ref={toast} />            
      </>  
    );
  
}
